<template>
  <v-breadcrumbs :items="items">
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item
          :href="item.href"
          :disabled="item.disabled"
      >
        {{ item.text.toUpperCase() }}
      </v-breadcrumbs-item>
    </template>
    <div class="card_container" >
      <div v-if="is_loading" class="loading-container" >
        <img src="../../assets/loading.svg" >
      </div>
      <div class="card_header" >
        <h2>รายงานการเบิกสินค้าประจำวัน</h2>
        <div class="date-picker-container" >
          <date-range-picker
              v-model="dateRange"
              :auto-apply=true
              :show-dropdowns=true
              :ranges=Ranges
              :locale-data=Lang
              :date-format="dateFormat"
              @select=SetDate
          ></date-range-picker>
        </div>
      </div>
      <div ref="table" class="table-report-container" align="center" >
        <table ref="table"   border="1" >
          <tr>
            <td style="border: none; text-align: center; vertical-align: middle;padding: 1rem"   align="center" colspan="4" >

              <img v-if="logo" style="margin-top: 10px;" width="150" :src="logo" />
              <img v-else style="margin-top: 10px;" width="150" src="https://app.yn-engineering.com/logo.png" />

            </td>
            <td style="border: none; text-align: center; vertical-align: middle;padding: 1rem" colspan="7" align="center" >
              <div align="center" >
                <p v-html="address" style="width: 70%"  >
                </p>
              </div>


            </td>

          </tr>
          <tr>
            <th>ลำดับที่</th>
            <th>วันที่เบิกสินค้า</th>
            <th>เวลาเบิกสินค้า</th>
            <th>รหัสผู้เบิก</th>
            <th>ชื่อผู้เบิก</th>
            <th>ชื่อชิ้นงาน<br>(รหัสสินค้า)</th>
            <th>รายละเอียดสินค้า</th>
            <th>ประเภทสินค้า</th>
            <th>จำนวนที่เบิก</th>
            <th>หน่วยนับ</th>
            <th>หมายเหตุ</th>
            <th>การคืนสินค้า</th>
          </tr>

          <tr class="row-table-custom" v-for="(result, index) in resultData" v-bind:key="result.id"  >
            <td>{{ (index+1) }}</td>
            <td>{{ getDates(result.createdAt)  }}</td>
            <td>{{ dateTimes(result.createdAt) }}</td>
            <td>{{ result.users.user_name }}</td>
            <td>{{ result.users.first_name+" "+result.users.last_name }}</td>
            <td>{{ result.product.name }}</td>
            <td>{{ result.product.code }}</td>
            <td>{{ result.category.title }}</td>
            <td>{{ result.amount }}</td>
            <td>{{ result.product.unit }}</td>
            <td>{{ result.note }}</td>
            <td>{{ result.receive == 0 ? "-" : result.receive == "1"  ?  "คืนเพื่อทิ้ง" : "คืนเพื่อส่งลับคม"  }}</td>
          </tr>

        </table>
      </div>
      <div align="center" >
        <button type="button" class="btn-export" @click="tableToExcel()"> ส่งออกข้อมูล</button>
      </div>

    </div>
  </v-breadcrumbs>



</template>

<script>
import {DeleteProduct, GetMachine, GetOrderReport} from "../../lib/controller";
import moment from "moment";
import {api_report, baseUrl} from "../../const/api";

let today = new Date()
today.setHours(0, 0, 0, 0)

let yesterday = new Date()
yesterday.setDate(today.getDate() - 1)
yesterday.setHours(0, 0, 0, 0);

export default {
  name: "Users",
  data: () => (
      {
        dateRange: {
          startDate: today,
          endDate: today,
        },
        Ranges:{
          'วันนี้': [today, today],
          'เมื่อวาน': [yesterday, yesterday],
          'ปีนี้': [new Date(today.getFullYear(), 0, 1), new Date(today.getFullYear(), 11, 31)],
          'เดือนก่อน': [new Date(today.getFullYear(), today.getMonth() - 1, 1), new Date(today.getFullYear(), today.getMonth(), 0)],
        },
        Lang:{
          direction: 'ltr',
          format: 'mm-dd-yyyy',
          separator: ' - ',
          applyLabel: 'ตกลง',
          cancelLabel: 'ยกเลิก',

          weekLabel: 'W',
          customRangeLabel: 'เลือกช่วงเวลา',
          daysOfWeek: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ', 'ศ', 'ส'],
          monthNames: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
          firstDay: 1
        },
    resultData:{},
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    param: {},
    is_loading:false,
    logo:'',
    machine_id: 99,
    machine_item: {},
    machine: {},
    uri :'data:application/vnd.ms-excel;base64,',
    template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
    base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
    format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) },
    selectedDate: {
    start: '',
    end: '',
    },
        address:'บริษัท วายเอ็น เอ็นจิเนียริ่ง โซลูชั่น จำกัด<br>' +
            'เลขที่ 2/8 ถ.รามคำแหง แขวงมีนบุรี เขตมีนบุรี กทม.10510<br>' +
            'โทร .02-917-5536 แฟกซ์ 02-917-5537',
        address_default:'บริษัท วายเอ็น เอ็นจิเนียริ่ง โซลูชั่น จำกัด<br>' +
            'เลขที่ 2/8 ถ.รามคำแหง แขวงมีนบุรี เขตมีนบุรี กทม.10510<br>' +
            'โทร .02-917-5536 แฟกซ์ 02-917-5537'
  }
  ),
  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    },
  },
  watch: {

  },
  created () {
    this.initialize()

    const user = JSON.parse(localStorage.getItem('user'));
    console.log(user.machine_id)
    this.machine_id = user.machine_id;
    this.GetMachines()
  },

  methods: {
    dateFormat (classes, date) {
      if (classes.disabled) {
        classes.disabled = date.getTime() < new Date()
      }
      return classes
    },
    getDates(date){
      let dates = moment(date).format('DD/MM/YYYY').split("/");
      //console.log(dates)
      return dates[0]+"/"+dates[1]+"/"+(parseInt(dates[2])+543);
      //return date;
      //console.log(moment(date))
      //return moment(date)
    },
    async GetMachines(){
      let machine = [];
      const { status , results } = await GetMachine();
      if(status === 200){

        machine.push({
          "label":"ทั้งหมด",
          "id":99,
        })

        results.data.forEach(function (result){
          console.log(result)
          machine.push({
            "label":result.title,
            "id":result.machine_number,
          })
        });
      }

      this.machine_item = machine;
      this.machine = results.data;

      this.getData()

      console.log(this.machine_item)

    },
    dateTimes(date){
      //console.log(date)
      return moment(date).format('HH:mm');
      //return date;
      //return moment(date)
    },
    tableToExcel(){
      console.warn(new URLSearchParams(this.param).toString());
      console.warn(api_report);
      window.location = api_report+"/report-product?"+ new URLSearchParams(this.param).toString();
    },
   async editItem(id) {
     this.$router.push({ path: '/Product/'+id })
    },
    async deleteItem(id){
      console.log(id)
      this.$swal({
        title: 'ต้องการลบใช่หรือไม่ ?',
        showCancelButton: true,
        confirmButtonText: 'ตกลง',
        cancelButtonText:"ยกเลิก",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            this.delete(id)
        }
      })

      ;
    },
    initialize () {

    },
   async SetDate(e){
      console.log(e)
      this.dateRange.startDate = e.startDate;
      this.dateRange.endDate = e.endDate;
      await this.getData();
    },
   async getData(){


     this.is_loading = true;
      let params = {};

     let date_start = new Date(this.dateRange.startDate)
     let date_end =  new Date(this.dateRange.endDate)
     let new_date = date_end.setDate(date_end.getDate() + 1);
     date_end = new Date(new_date);


     params.date_start = date_start
     params.date_end = date_end





     if(this.date.length !== 0){
       if(this.date.length === 1){

         params.date_start = this.date[0];

         let date_start = new Date(this.date[0])
         let date_end =  new Date(this.date[0])
         let new_date = date_end.setDate(date_end.getDate() + 1);
         date_end = new Date(new_date);


         params.date_start = date_start
         params.date_end = date_end
       }
       if(this.date.length === 2){

         if(this.date[0] === this.date[1]){


           params.date_start = this.date[0];

           let date_start = new Date(this.date[0])
           let date_end =  new Date(this.date[0])
           let new_date = date_end.setDate(date_end.getDate() + 1);
           date_end = new Date(new_date);


           params.date_start = date_start
           params.date_end = date_end


         }else{
           params.date_start = this.date[0]
           params.date_end = this.date[1]
         }




       }

     }else{


       let date_start = new Date(this.date)
       let date_end =  new Date(this.date)
       let new_date = date_end.setDate(date_end.getDate() + 1);
       new_date = new Date(new_date);


       params.createdAt = { "$gte": date_start,"$lt": new_date };

     }


     params.machine_id = this.machine_id

     const match = this.machine.find(item => item.machine_number === this.machine_id);

     if (match) {
       if (match.logo) {
         this.logo = baseUrl + '/' + match.logo.path.replace('media', '');
       }else{
         this.logo = "";
       }
       if (match.address) {
         this.address = match.address;
       }else{
         this.address = this.address_default;
       }
     }

     console.log(params)


     this.param = params;


      const { status,results } = await GetOrderReport(params);

     this.is_loading = false;

      if(status === 200){

        let uniqueIds = new Set();
        let uniqueArray = results.data.filter(item => {
          const isDuplicate = uniqueIds.has(item._id);
          uniqueIds.add(item._id);
          return !isDuplicate;
        });

        this.resultData = uniqueArray;
      }


    },
    async delete(id){
      let Swal = this.$swal;
      const { status } = await DeleteProduct(id);
      if(status === 200){
        Swal({
          icon: 'success',
          title: 'Success',
        })
       await this.getData()
      }
    },

  },
}


</script>

<style scoped>
.card_container{
  width: 100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #EBEDF3;
  border-radius: 0.42rem;
}
.card_header{
  padding: 1.5rem 2rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 1px solid #ebedf3;
  display: flex;
  gap: 2rem;
  justify-content: flex-start;
  align-items: center;
}
.img_thumb{
  width:8rem;
  border-radius:10px;
  margin:0.2rem;
}
.date-picker-container{
  display: flex;
  align-content: center;
  align-items: center;
  column-gap: 10px;
}
.table-report-container{

}
.table-report-container > table{
  width: 70%;
  border:1px solid #000;
  border-collapse: collapse;
}
.date-picker-container{
  display: flex;
  column-gap: 10px;
  align-items: center;
  align-content: center;
}
.daterangepicker .ranges ul {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
}

</style>
